export interface CernerSlot {
  appointmentDateTime?: Date;
  daysToAppointment?: string;
  slotId?: string;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestSlotList = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    appointmentDateTime: new Date(2024, 4, 31, 10, 0),
    daysToAppointment: '',
    slotId: `slot${index}`,
  }));
